<template>
  <div id="insurance-success">
    <div class="bread">
      <router-link class="bread-item" to="/">上上签</router-link>
      <div class="bread-arrow">&gt;</div>
      <router-link class="bread-item" :to="'/insurances'">保险商城</router-link>
      <div class="bread-arrow">&gt;</div>
      <div class="bread-item bread-ellipsis">{{productName}}</div>
    </div>

    <!-- 支付成功 -->
    <div class="insurance-success">
      <img :src="$importImage('insurance/insurance-success.png')" alt="">
      <div class="success-title">支付成功</div>
      <div class="success-content">电子保单会在30分钟内以邮件形式发送至邮箱： <span>{{email}}</span></div>
      <div class="success-content">保险由第三方提供，如需开具发票，请联系客服电话 400-678-8169 </div>
      <div class="success-button">
        <el-button class="is-plain" type="primary" @click="chooseJumpUrl(1)">继续投保</el-button>
        <el-button type="primary" @click="chooseJumpUrl(2)">查看订单</el-button>
      </div>
    </div>

  </div>
</template>

<script>
import insuranceOrderNav from '../../../components/insurance-order-nav';

export default {
  name: 'insuranceSuccess',
  data() {
    return {
      email: this.$route.query.email,
      caseCode: this.$route.query.case_code,
      productName: this.$route.query.product_name,
      insuranceUrl: this.$route.query.insuranceUrl,
    };
  },
  computed: {

  },
  components: {
    insuranceOrderNav,
  },
  methods: {
    chooseJumpUrl(choice) {
      if (choice === 2) {
        // window.open(this.insuranceUrl);
        // 改为跳转到 我的订单——保险 tab
        this.$router.push({ name: 'orders', query: { tab: 'insurance' } });
      } else {
        this.$router.push({ name: 'insurances' });
      }
    },
  },
  created() {
  },
};
</script>

<style lang="less" scoped>
@import "../../../assets/less/variable";

#insurance-success {
  width: 1000px;
  margin: 0 auto 50px;
  .insurance-success {
    height: 500px;
    background-color: @white;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
    padding: 44px;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-radius: 4px;
    img {
      margin-bottom: 25px;
    }
    .success-title {
      font-size: 26px;
      color: @text-dark;
      margin-bottom: 25px;
      font-weight: bold;
    }
    .success-content {
      font-size: 14px;
      color: @text-sliver;
      margin-bottom: 20px;
      span {
        font-weight: bold;
      }
    }
    .success-button {
      margin-top: 25px;
    }
  }

}
</style>
<style lang="less">
#insurance-success {
  .el-button {
    width: 240px;
    height: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/insurance/insuranceOrder/InsuranceSuccess.vue